import React from "react";
import { Link } from "react-router-dom";

/**
 * Call to action section that encourages users to take action
 */
const CallToActionSection = () => {
  return (
    <div
      className="section"
      data-aos="fade-up"
      style={{ backgroundColor: "#ffffff" }}
    >
      <div className="container">
        <div className="cta-holder-06">
          <div className="cta-left-right-grid">
            <div className="fade-in-on-scroll">
              <div className="cta-heading-holder ease-larger">
                <h3 className="second-title" style={{ color: "#1a1a1a" }}>
                  Start using EduTools today
                </h3>
              </div>
            </div>
            <div className="fade-in-on-scroll">
              <div className="cta-button-holder">
                <a
                  to="/download"
                  className="button secondary w-inline-block"
                >
                  <div>Explore</div>
                  <img
                    loading="lazy"
                    src="./images/Arrow-Right.svg"
                    alt="Arrow Right"
                    className="button-arrow-icon"
                  />
                </a>
                <div>
                  <Link to="/download" className="button">
                    <div>Download</div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallToActionSection;
